import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ToastrService } from 'ngx-toastr';
import { MetaPixelService } from 'src/app/services/metapixel.service';
import { SignupService } from '../../services/signup.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { InstantCalculatorDisocuntCountdownService } from 'src/app/services/instant-calculator-disocunt-countdown.service';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
@Component({
  selector: 'app-shipping-price-calculation',
  templateUrl: './shipping-price-calculation.component.html',
  styleUrls: ['./shipping-price-calculation.component.css'],
})
export class ShippingPriceCalculationComponent implements OnInit {
  remainingTime: { minutes: number; seconds: number };
  timerFinished: boolean = false;
  hostCountries;
  allCountries;
  countryFrom;
  countryTo;
  weightUnit;
  dimensionUnit;
  weight;
  width;
  height;
  length;
  priceText;
  priceError = false;
  priceErrorText = '';
  isLoading = false;
  isUS = false;
  hasCourierOptions = false;
  courierData;

  user: string;
  loggedUser: boolean = false;
  token;
  userID;

  form = new UntypedFormGroup({
    weight: new UntypedFormControl(0),
    width: new UntypedFormControl(0),
    height: new UntypedFormControl(0),
    length: new UntypedFormControl(0),
    weightUnit: new UntypedFormControl('lbs', Validators.required),
    dimensionUnit: new UntypedFormControl('inch', Validators.required),
  });

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public signUpService: SignupService,
    private toastr: ToastrService,
    private $gaService: GoogleAnalyticsService,
    private metaPixelService: MetaPixelService,
    private clipboard: Clipboard,
    private watcherService: WatcherService,
    private store: Store<AppState>,
    private _icdcService: InstantCalculatorDisocuntCountdownService,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
      this.user = state.user;
      this.loggedUser = state.isAuthenticated;
    });
    this.priceText = 0.0;
    this.oldPriceText = 0.0;

    this.signUpService.getAllCountries().subscribe((list) => {
      this.allCountries = list['data'];
    });
    this.signUpService.getUserIPData().subscribe((data) => {
      this.countryTo = data['country'] === 'GB' ? 'UK' : data['country']
    });
  }
  lang;
  private localStorageKey = 'countdown_timer';
  ngOnInit(): void {
    this.signUpService.getHostCountries().subscribe((list) => {
      let hostCountries = list['data'];

      const countriesVIP = [
        'United States of America',
        'United Kingdom',
        'Australia',
        'Canada',
        'Germany',
        'Japan',
        'France',
        'Netherlands',
        'Italy',
        'Sweden',
      ];
      this.hostCountries = hostCountries.sort((a, b) => {
        const indexA = countriesVIP.findIndex(
          (vip) => vip.toLowerCase() === a.name.toLowerCase()
        );
        const indexB = countriesVIP.findIndex(
          (vip) => vip.toLowerCase() === b.name.toLowerCase()
        );

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return a.name.localeCompare(b.name);
        }
      });

      this.hostCountries.forEach((country) => {
        country.code = country.code.toUpperCase();  
      })
 
      
      this.countryFrom = 'US';
    });
    this.isThereADiscount = false;
    this._icdcService.getRemainingTime().subscribe((time) => {
      this.remainingTime = time;
      if (this.remainingTime.minutes > 0 || this.remainingTime.seconds > 0) {
        this.isThereADiscount = true;
      } else if (
        time.minutes === 0 &&
        time.seconds === 0 &&
        this.isThereADiscount === true
      ) {
        this.isThereADiscount = false;
        this.calculatePrice();
      }
    });
    window.scrollTo(0, 0);
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    this._icdcService.getTimerFinishedSignal().subscribe((finished) => {
      const stateString = JSON.parse(
        localStorage.getItem(this.localStorageKey)
      );
      this.timerFinished = finished;

      if (this.timerFinished === true && !stateString.shown) {
        this.isThereADiscount = false;
        this.calculatePrice();
        const modalCloser = this.document.getElementById(
          'icdcModalCloseTrigger'
        );
        modalCloser.click();
      }
    });
    // setTimeout(()=>{
    //   this._icdcService.startCountdown();
    // }, 30000)
  }
  backUS() {
    this.isUS = false;
  }
  checkInputValidations() {
    var hasError = false;
    if (
      this.form.controls.weight.status == 'INVALID' ||
      this.form.value.weight == 0
    ) {
      this.form.controls.weight.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.width.status == 'INVALID') {
      this.form.controls.width.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.height.status == 'INVALID') {
      this.form.controls.height.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.length.status == 'INVALID') {
      this.form.controls.length.markAsTouched();
      hasError = true;
    }
    return hasError;
  }
  calculatePrice() {
    if (this.checkInputValidations() == false) {
      let { started, finished, shown } = this._icdcService.getTimerStatus();
      const timerState = JSON.parse(localStorage.getItem(this.localStorageKey));

      if (this.isThereADiscount === true && !finished && timerState) {
        this.calculatePriceWithDiscount();
      } else {
        this.isLoading = true;
        this.priceText = 0.0;
        this.oldPriceText = 0.0;
        var amountArray = [];
        this.signUpService
          .calculatePricing(
            '',
            this.countryTo.toUpperCase(),
            this.countryFrom.toUpperCase(),
            this.form.value.weight ?? 0,
            this.form.value.weightUnit,
            this.form.value.width ?? 0,
            this.form.value.height ?? 0,
            this.form.value.length ?? 0,
            this.form.value.dimensionUnit,
            ''
          )
          .subscribe((data) => {
            if (data['result']['status'] != 200) {
              this.priceError = true;
              this.priceErrorText = data['result']['message'];
              this.toastr.error(data['result']['message'], 'Error');
              this.isLoading = false;
              this.hasCourierOptions = false;
            } else {
              if (data['data']['shipment_amount']?.length > 0) {
                this.hasCourierOptions = true;

                const filteredData = data['data']['shipment_amount'].map(
                  (item) => {
                    return {
                      ...item,
                      shipment_amount_after_discount:
                        item.shipment_amount_after_discount.toFixed(2),
                      total_shipment_amount:
                        item.total_shipment_amount.toFixed(2),
                    };
                  }
                );
                this.courierData = filteredData;

                setTimeout(() => {
                  let { started, finished, shown } =
                    this._icdcService.getTimerStatus();
                  const stateString = JSON.parse(
                    localStorage.getItem(this.localStorageKey)
                  );
                  if (
                    (!this.isThereADiscount &&
                      shown === 0 &&
                      !started &&
                      !finished) ||
                    !stateString
                  ) {
                    this.calculatePriceWithDiscount();
                  }
                }, 5000);
                this.isLoading = false;
              }
              for (
                let index = 0;
                index < data['data']['shipment_amount']?.length;
                index++
              ) {
                amountArray.push(
                  data['data']['shipment_amount'][index][
                    'shipment_amount_after_discount'
                  ]
                );
              }
              if (this.userID && this.token) {
                this.signUpService
                  .getUserByUserID(this.userID, this.token)
                  .subscribe((user) => {
                    let metaPixelEventObject = {
                      country_from: this.countryFrom,
                      country_to: this.countryTo,
                      user_email: user['data'].email,
                    };
                    //this.metaPixelService.onPricingCalculation( metaPixelEventObject);
                  });
              } else {
                let metaPixelEventObject = {
                  country_from: this.countryFrom,
                  country_to: this.countryTo,
                };
                //this.metaPixelService.onPricingCalculation(metaPixelEventObject);
              }
              this.$gaService.event(
                'calculate_price',
                'calculate_price',
                this.countryFrom + '-' + this.countryTo
              );
              const gtmTag = {
                event: 'gtmCalculatePrice',
                data: {
                  countryFrom: this.countryFrom,
                  countryTo: this.countryTo,
                },
              };
              this.gtmService.pushTag(gtmTag);
              if (amountArray.length > 0) {
                this.priceText = Math.min.apply(Math, amountArray);
              } else {
                this.priceText = 0;
                this.oldPriceText = 0;
              }
              this.isLoading = false;
              this.priceError = false;
            }
          });
      }
    }
  }
  oldPriceText = 0;
  isThereADiscount: boolean = false;
  calculatePriceWithDiscount() {
    let discountCode = 'INSTANT10';
    let payload;

    this.priceText = 0.0;
    this.oldPriceText = 0.0;
    var amountArray = [];

    let { started, finished } = this._icdcService.getTimerStatus();

    payload = {
      country_to: this.countryTo.toUpperCase(),
      country_from: this.countryFrom.toUpperCase(),
      dimension: {
        weight: this.form.value.weight ?? 0,
        weight_unit: this.form.value.weightUnit,
        height: this.form.value.height ?? 0,
        width: this.form.value.width ?? 0,
        length: this.form.value.length ?? 0,
        dimension_unit: this.form.value.dimensionUnit,
      },
      shopper_id: '',
      promo_code: discountCode,
    };
    this.signUpService
      .calculatePricingWithDiscount('', payload)
      .subscribe((data) => {
        if (data['result']['status'] != 200) {
          this.priceError = true;
          this.priceErrorText = data['result']['message'];
          this.toastr.error(data['result']['message'], 'Error');
          this.isLoading = false;
          this.hasCourierOptions = false;

          // Temp
          this.isThereADiscount = true;
          this._icdcService.startCountdown();
        } else {
          this.isLoading = false;
          if (data['data']['shipment_amount']?.length > 0) {
            this.hasCourierOptions = true;
            const filteredData = data['data']['shipment_amount'].map((item) => {
              return {
                ...item,
                shipment_amount_after_discount:
                  item.shipment_amount_after_discount.toFixed(2),
                total_shipment_amount: item.total_shipment_amount.toFixed(2),
              };
            });
            this.courierData = filteredData;

            this.document.getElementById('icdcModalTrigger').click();

            this.isThereADiscount = true;
            this._icdcService.startCountdown();
          }
          for (
            let index = 0;
            index < data['data']['shipment_amount']?.length;
            index++
          ) {
            amountArray.push(
              data['data']['shipment_amount'][index][
                'shipment_amount_after_discount'
              ]
            );
          }
          if (this.userID && this.token) {
            this.signUpService
              .getUserByUserID(this.userID, this.token)
              .subscribe((user) => {
                let metaPixelEventObject = {
                  country_from: this.countryFrom,
                  country_to: this.countryTo,
                  user_email: user['data'].email,
                };
                //this.metaPixelService.onPricingCalculation(metaPixelEventObject);
              });
          } else {
            let metaPixelEventObject = {
              country_from: this.countryFrom,
              country_to: this.countryTo,
            };
            //this.metaPixelService.onPricingCalculation(metaPixelEventObject);
          }
          this.$gaService.event(
            'calculate_price',
            'calculate_price',
            this.countryFrom + '-' + this.countryTo
          );
          const gtmTag = {
            event: 'gtmCalculatePrice',
            data: {
              countryFrom: this.countryFrom,
              countryTo: this.countryTo,
            },
          };
          this.gtmService.pushTag(gtmTag);
          if (amountArray.length > 0) {
            this.oldPriceText =
              +data['data']['shipment_amount'][0]['total_shipment_amount'];
            this.priceText = Math.min.apply(Math, amountArray);
          } else {
            this.priceText = 0;
            this.oldPriceText = 0;
          }
          this.isLoading = false;
          this.priceError = false;
        }
      });
  }
  copyBF() {
    this.clipboard.copy('BLACKFRIDAY15');
    this.toastr.success('BLACKFRIDAY15 is copied to clipboard', 'Success');
  }

  goToDiscountedShopFrom() {
    this.router.navigate(['/','shop-from', this.countryFrom]);
  }
}
